// graphQL
export const URL_HIRER_GRAPH = '/graphql';
export const URL_HIRER_GRAPH_LOCAL = `http://localhost:4000${URL_HIRER_GRAPH}`;
export const URL_HIRER_GRAPH_STAGING = `https://talent.staging.seek.com.au${URL_HIRER_GRAPH}`;
